class RecommendedProduct extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
    this.select = [];
    this.variantData = [];

    // Observe when Shopify replaces innerHTML
    this._observer = new MutationObserver(() => {
      this.initialize();
    });
  }

  connectedCallback() {
    if (!this._initialized) {
      this._initialized = true;

      // observe internal DOM changes
      this._observer.observe(this, {
        childList: true,
        subtree: true,
      });
    }

    // initial init
    this.initialize();
  }

  initialize() {
    // wait until DOM is painted
    requestAnimationFrame(() => {
      this.select = this.querySelectorAll("select");
      this.variantData = JSON.parse(this.dataset.variants || "[]");

      if (!this.select?.length) return;

      if (this.select.length === 1) {
        this.applySingleVariant();
      } else {
        this.applyMultiVariant();
      }
    });
  }

  applySingleVariant() {
    const el = this.select[0];
    el.removeEventListener("change", this._singleHandler);
    this._singleHandler = () => {
      const hiddenInput = this.querySelector(".hidden__id");
      if (hiddenInput) hiddenInput.value = el.value;
    };
    el.addEventListener("change", this._singleHandler);
  }

  applyMultiVariant() {
    this.select.forEach((selectEl, ind) => {
      // cleanup old listeners to avoid duplicates
      selectEl.removeEventListener("change", this._multiHandler);
      this._multiHandler = () => this.handleVariantChange(ind);
      selectEl.addEventListener("change", this._multiHandler);
    });

    this.updateAvailableOptions(0);
  }

  handleVariantChange(ind) {
    this.updateAvailableOptions(ind);

    const newSelectedOptions = Array.from(this.select).map((s) =>
      s.value.trim().toLowerCase()
    );

    const matchedVariant = this.variantData.find((variant) =>
      newSelectedOptions.every(
        (opt, i) => opt === variant.options[i]?.trim().toLowerCase()
      )
    );

    if (matchedVariant) {
      const hiddenInput = this.querySelector(".hidden__id");
      if (hiddenInput) hiddenInput.value = matchedVariant.id;
    }
  }

  updateAvailableOptions(changedIndex) {
    const selectedValues = Array.from(this.select).map((s) =>
      s.value.trim().toLowerCase()
    );

    const selectedVariants = this.variantData.filter((v) => {
      const optionValue = v.options[changedIndex]?.trim().toLowerCase();
      return optionValue === selectedValues[changedIndex];
    });

    const availableVariants = selectedVariants.filter((v) => v.available);

    this.select.forEach((sel, i) => {
      if (i === changedIndex) return;

      Array.from(sel.options).forEach((optEl) => {
        const optValue = optEl.value.trim().toLowerCase();
        const isAvailable = availableVariants.some((vr) => {
          const opts = vr.options.map((o) => o.toLowerCase());
          return opts[i] === optValue;
        });
        optEl.disabled = !isAvailable;
      });
    });
  }
}

customElements.define("recommended-product", RecommendedProduct);